module.exports = __webpack_public_path__ + "img/portrait.850872e1.png";